import { Head, usePage } from "@inertiajs/react";

function Show() {
  const { current_tenant } = usePage().props;

  return (
    <>
      <Head title="Kontrolpanel" />

      <div className="container py-4">
        <h1>Kontrolpanel</h1>
        <p>Hej. Du er nu i {current_tenant?.name}.</p>
      </div>
    </>
  );
}

export default Show;
